import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { Editor } from "@tinymce/tinymce-react";
import "../css/Loaders.css";

const GOLD = "#d9a128";
const SPINNER_PX = 36;

export function GoldLoader({ label = "Loading...", variant = "page" }) {
  return (
    <div
      className={`gold-loader gold-loader--${variant}`}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      <Spinner
        animation="border"
        role="presentation"
        style={{ color: GOLD, width: SPINNER_PX, height: SPINNER_PX }}
      />
      {label ? <span className="gold-loader__label">{label}</span> : null}
    </div>
  );
}

export function DataTableLoader() {
  return <GoldLoader label="Loading..." variant="page" />;
}

export function GoldTinyMce({ onInit, init, ...props }) {
  const [ready, setReady] = useState(false);
  const height = init?.height || 246;
  return (
    <div
      className={ready ? "gold-tinymce gold-tinymce--ready" : "gold-tinymce"}
      style={{ minHeight: ready ? undefined : height }}
    >
      {!ready ? <GoldLoader label="Loading..." variant="page" /> : null}
      <Editor
        {...props}
        init={init}
        onInit={(evt, editor) => {
          setReady(true);
          if (onInit) onInit(evt, editor);
        }}
      />
    </div>
  );
}
